import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Swal from "sweetalert2";
import { loginState, configState } from "../lib/State"; // 로그인 (1)
import get_session from "../lib/get_session"; // 로그인(2);
import Loading from "./Loading";
import pr from "../lib/pr";
import get_token from "../lib/get_token";
import axios from "axios";
import { List, ListItemText, ListItem, ListItemButton } from "@mui/material";

// 프로필 > 쿠폰
const TestCouponLoggedIn = (props) => {
  const { login } = props;
  const [loaded, setLoaded] = useState(false);
  const token = get_token();
  const [rows, setRows] = useState([]);

  // 쿠폰 가져오기
  const get_list = async () => {
    let result = await axios.post(configState.api+"/gympass/my_coupon", {
      token: token,
      cid: configState.cid,
      mcd: login.mcd,
      level: login.level,
    });
    setRows(result.data.rows);
  };
  useEffect(() => {
    get_list();
  }, []);

  const onReserveClick = (event) => {
      pr(event.target.value);
  } 

  return (
    <List>
      {rows.map((item, index) => {
          const pt_type = item.pt_type;
        return (
          <ListItem key={index}>
            <ListItemText
              primary={`유효기간 ${item.enroll_sdate} ~ ${item.enroll_edate}`}
            />
            <ListItemText primary={`발급일 ${item.regdate}`} />
            <ListItemText primary={`${pt_type}쿠폰`} />
            <ListItemText primary={`보유:${item.total_count}장`} />
            <ListItemText primary={`사용:${item.use_count}장`} />
            
            {/* 클래스쿠폰 예약 */}
            { pt_type==='클래스'?
            <Button variant="contained" value={item.seq} onClick={onReserveClick}>예약</Button>:null }

          </ListItem>
        );
      })}
    </List>
  );
};

// 부모 컴퍼넌트
function TestCoupon() {
  const [login, setLogin] = useState(loginState); // 로그인 (3)
  const [loaded, setLoaded] = useState(false); // 로그인 (4)

  const init = async () => {
    // 로그인 (5)
    let result = await get_session();
    if (result.data.mcd !== "" && result.data.success === 1) {
      setLogin({ mcd: result.data.mcd, level: result.data.level });
    }
    setLoaded(true);
  };
  useEffect(() => {
    init();
  }, []);

  return (
    <Box sx={{ p: 1 }}>
      {!loaded ? <Loading></Loading> : <TestCouponLoggedIn login={login} />}
    </Box>
  );
}

export default TestCoupon;
